import { useState } from "react";
import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import styled from "styled-components";
import { addImagesToGallery } from "../../utils/api-calls";
import { rel8Purple } from "../../globals";

const UploadContainer = styled.div`
  margin: 18px 0 12px  0;
  padding: 12px 16px;
  border: 1px dashed #ccc;
  border-radius: 8px;
`;

const UploadHeader = styled.h3`
  margin-top: 0;
  margin-bottom: 8px;
`;

const FormInput = styled.input`
    padding: 5px 0px;
    margin-right: 16px;
    background-color: transparent;
    border: none;
    border: 1px solid ${rel8Purple};
    border-radius: 5px;
    padding: 5px;
    color: ${rel8Purple};
    outline: none;
    &::placeholder {
      color: ${rel8Purple};
    }
`;

const UploadButton = styled.button`
  background: ${props => props.disabled ? '#cccccc' : '#4CAF50'};
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  
  &:hover {
    background: ${props => props.disabled ? '#cccccc' : '#45a049'};
  }
`;


export const AddGalleryImages = ({ galleryId }) => {
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const queryClient = useQueryClient();

    const handleFileChange = (e) => {
        if (e.target.files) {
            setFiles(Array.from(e.target.files));
        }
    }

    const uploadImagesMutation = useMutation(
      (data) => addImagesToGallery(galleryId, data),
      {
        onSuccess: () => {
          toast.success("Images added successfully");
          setUploading(false);
          queryClient.invalidateQueries(`gallery-${galleryId}`);
        },
        onError: () => {
          toast.error("Error adding images");
          setUploading(false);
        }
      }
    );

    const handleUpload = () => {
      if (files.length === 0) {
        return;
      }
      const formData = new FormData();
      files.forEach((file) => formData.append('upload_images', file));

      uploadImagesMutation.mutate(formData);
    }

    return (
        <UploadContainer>
            <UploadHeader>Add More Images</UploadHeader>
            <FormInput
                type="file"
                accept="image/*"
                multiple
                onChange={handleFileChange}
                disabled={uploading}
            />
            <UploadButton
                onClick={handleUpload}
                disabled={files.length === 0 || uploading}
            >
                {uploading ? 'Uploading...' : 'Upload Images'}
            </UploadButton>
        </UploadContainer>
    )
    
}